var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("section", { staticClass: "pt-3 mt-3", attrs: { id: "kalkulator" } }, [
      _c(
        "ul",
        {
          staticClass: "nav nav-tabs",
          attrs: { id: "kkTabs", role: "tablist" },
        },
        [
          _c(
            "li",
            { staticClass: "nav-item", attrs: { role: "presentation" } },
            [
              _c(
                "button",
                {
                  staticClass: "nav-link active",
                  attrs: {
                    id: "k-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#kalkulator-tab",
                    type: "button",
                    role: "tab",
                    "aria-controls": "kalkulator-tab",
                    "aria-selected": "true",
                  },
                },
                [
                  _vm._v(_vm._s(_vm.$t("ic_kk_znam_oferte"))),
                  _c("br"),
                  _vm._v(_vm._s(_vm.$t("ic_kk_zamow_karte"))),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "nav-item", attrs: { role: "presentation" } },
            [
              _c(
                "button",
                {
                  staticClass: "nav-link",
                  attrs: {
                    id: "f-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#rozmowa",
                    type: "button",
                    role: "tab",
                    "aria-controls": "rozmowa",
                    "aria-selected": "false",
                  },
                },
                [
                  _vm._v(_vm._s(_vm.$t("ic_kk_chce_poznac_szczegoly"))),
                  _c("br"),
                  _c("i", { staticClass: "bi bi-telephone" }),
                  _vm._v(" " + _vm._s(_vm.$t("ic_kk_zamow_rozmowe"))),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-6 tab-content" }, [
          _c(
            "div",
            {
              staticClass: "tab-pane fade show active",
              attrs: { id: "kalkulator-tab" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "form d-flex justify-content-center flex-column align-items-center",
                },
                [
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("ic_kk_wybierz_swoja_karte"))),
                  ]),
                  _vm._v(" "),
                  _c("FormWrapper", { attrs: { id: "kalkulator" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group d-none",
                        class: {
                          "has-error":
                            !_vm.kalkulator.ilosc && _vm.kalkulator.isTouched,
                        },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "sr-only",
                            attrs: { id: "ilosc_label" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "ic_kk_wybierz_liczbe_przejazdow_i_oblicz"
                                )
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("ic-select", {
                          attrs: {
                            id: "ilosc",
                            values: _vm.ilosci,
                            searchable: true,
                            allowEmpty: false,
                            placeholder: _vm.$t(
                              "ic_kk_wybierz_liczbe_przejazdow"
                            ),
                            required: "",
                          },
                          model: {
                            value: _vm.kalkulator.ilosc,
                            callback: function ($$v) {
                              _vm.$set(_vm.kalkulator, "ilosc", $$v)
                            },
                            expression: "kalkulator.ilosc",
                          },
                        }),
                        _vm._v(" "),
                        !_vm.kalkulator.ilosc && _vm.kalkulator.isTouched
                          ? _c(
                              "label",
                              {
                                staticClass: "error",
                                attrs: {
                                  for: "ilosc",
                                  "aria-label": _vm.$t(
                                    "ic_kk_blad_pole_wymagane"
                                  ),
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("ic_kk_pole_wymagane")))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: {
                          "has-error":
                            !_vm.kalkulator.waznosc && _vm.kalkulator.isTouched,
                        },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "sr-only",
                            attrs: { id: "waznosc_label" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "ic_kk_wybierz_okres_waznosci_pole_wymagane"
                                )
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("ic-select", {
                          attrs: {
                            id: "waznosc",
                            values: _vm.waznoscOptions,
                            searchable: true,
                            allowEmpty: false,
                            placeholder: _vm.$t("ic_kk_wybierz_okres_waznosci"),
                            required: "",
                          },
                          model: {
                            value: _vm.kalkulator.waznosc,
                            callback: function ($$v) {
                              _vm.$set(_vm.kalkulator, "waznosc", $$v)
                            },
                            expression: "kalkulator.waznosc",
                          },
                        }),
                        _vm._v(" "),
                        !_vm.kalkulator.waznosc && _vm.kalkulator.isTouched
                          ? _c(
                              "label",
                              {
                                staticClass: "error",
                                attrs: {
                                  for: "waznosc",
                                  "aria-label": _vm.$t(
                                    "ic_kk_blad_pole_wymagane"
                                  ),
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("ic_kk_pole_wymagane")))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: {
                          "has-error":
                            !_vm.kalkulator.klasa && _vm.kalkulator.isTouched,
                        },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "sr-only",
                            attrs: { id: "klasa_label" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "ic_kk_wybierz_klase_podrozy_pole_wymagane"
                                )
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("ic-select", {
                          attrs: {
                            id: "klasa",
                            values: _vm.klasaOptions,
                            searchable: true,
                            allowEmpty: false,
                            placeholder: _vm.$t("ic_kk_wybierz_klase_podrozy"),
                            required: "",
                          },
                          model: {
                            value: _vm.kalkulator.klasa,
                            callback: function ($$v) {
                              _vm.$set(_vm.kalkulator, "klasa", $$v)
                            },
                            expression: "kalkulator.klasa",
                          },
                        }),
                        _vm._v(" "),
                        !_vm.kalkulator.klasa && _vm.kalkulator.isTouched
                          ? _c(
                              "label",
                              {
                                staticClass: "error",
                                attrs: {
                                  for: "klasa",
                                  "aria-label": _vm.$t(
                                    "ic_kk_blad_pole_wymagane"
                                  ),
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("ic_kk_pole_wymagane")))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: {
                          "has-error":
                            !_vm.kalkulator.type && _vm.kalkulator.isTouched,
                        },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "sr-only",
                            attrs: { id: "c_type_label" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("ic_kk_wybierz_typ_karty_pole_wymagane")
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("ic-select", {
                          attrs: {
                            id: "c_type",
                            values: _vm.typeOptions,
                            searchable: true,
                            allowEmpty: false,
                            placeholder: _vm.$t("ic_kk_wybierz_typ_karty"),
                            required: "",
                          },
                          model: {
                            value: _vm.kalkulator.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.kalkulator, "type", $$v)
                            },
                            expression: "kalkulator.type",
                          },
                        }),
                        _vm._v(" "),
                        !_vm.kalkulator.type && _vm.kalkulator.isTouched
                          ? _c(
                              "label",
                              {
                                staticClass: "error",
                                attrs: {
                                  for: "c_type",
                                  "aria-label": _vm.$t(
                                    "ic_kk_blad_pole_wymagane"
                                  ),
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("ic_kk_pole_wymagane")))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center btns" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn-primary btn me-5 mr-5 d-none",
                          on: {
                            click: function ($event) {
                              return _vm.oblicz(false, $event)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("ic_kk_oblicz_oszczednosci")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-success btn",
                          on: {
                            click: function ($event) {
                              return _vm.oblicz(true, $event)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("ic_kk_zamawiam_karte")))]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab-pane fade", attrs: { id: "rozmowa" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "form d-flex justify-content-center flex-column align-items-center",
                },
                [
                  _c("form", { attrs: { method: "post" } }, [
                    _c("div", { attrs: { id: "kalkulator" } }, [
                      _c("h3", { staticClass: "h4" }, [
                        _vm._v(_vm._s(_vm.$t("ic_kk_zamow_rozmowe_intro"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-floating" }, [
                        _c("input", {
                          staticClass: "form-control",
                          attrs: {
                            placeholder: "Wpisz numer telefonu",
                            id: "floatingTextarea",
                            required: "",
                            name: "phone",
                            maxlength: "9",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticStyle: { padding: "0.5rem 1.25rem" },
                            attrs: { for: "floatingTextarea" },
                          },
                          [_vm._v(_vm._s(_vm.$t("ic_kk_wpisz_numer_telefonu")))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check mt-3 ms-1" }, [
                        _c("input", {
                          staticClass: "form-check-input",
                          attrs: {
                            type: "checkbox",
                            value: "1",
                            id: "defaultCheck1",
                            required: "",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label text-white",
                            attrs: { for: "defaultCheck1" },
                          },
                          [
                            _vm._v(
                              "\n                                          " +
                                _vm._s(_vm.$t("ic_kk_zamow_rozmowe_zgoda")) +
                                "\n                                        "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex w-100 justify-content-center btns",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn-primary btn me-5 mr-5",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(_vm._s(_vm.$t("ic_kk_zamawiam_rozmowe")))]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "col-12 col-md-5 offset-md-1 mt-5 mt-md-0",
          domProps: { innerHTML: _vm._s(_vm.$t("ic_kk_prawa_strona")) },
        }),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "mt-5 pt-5",
        domProps: { innerHTML: _vm._s(_vm.$t("ic_kk_legal")) },
      }),
    ]),
    _vm._v(" "),
    _c(
      "section",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.kalkulator.isCalculated,
            expression: "kalkulator.isCalculated",
          },
        ],
        attrs: { id: "info" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "bg" }, [
              _c("h2", { staticClass: "text-center" }, [
                _vm._v(
                  _vm._s(_vm.$t("ic_kk_Karta idealna dla Twojego Biznesu"))
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "karta", class: _vm.kalkulator.wybrana.id },
                    [
                      _c("div", { staticClass: "head" }, [
                        _c("p", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("ic_kk_Karta INTERCITY"))
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.k_waznosc))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.k_typ))]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("ic_kk_KLASA")) +
                                " " +
                                _vm._s(_vm.kalkulator.klasa)
                            ),
                          ]),
                          _vm._v(" - "),
                          _c("span", [_vm._v(_vm._s(_vm.k_discount))]),
                          _vm._v(" "),
                          _c("br"),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _vm.kalkulator.wybrana.oszczednosc <= 0
                    ? _c("div", [
                        _c("div", { staticClass: "h3" }, [
                          _vm._v(_vm._s(_vm.$t("ic_kk_Cena")) + ":"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "h2" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatNumber")(
                                _vm.kalkulator.wybrana.cena
                              )
                            ) + " zł"
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.kalkulator.wybrana.id == "zlota" &&
                        _vm.kalkulator.klasa == 1
                          ? _c("p", { staticClass: "h4" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ic_kk_Oszczędzasz już przy 2 przejazdach tygodniowo"
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kalkulator.wybrana.id == "zlota" &&
                        _vm.kalkulator.klasa == 2
                          ? _c("p", { staticClass: "h4" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ic_kk_Oszczędzasz już przy 3 przejazdach tygodniowo"
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kalkulator.wybrana.id == "srebrna" ||
                        _vm.kalkulator.wybrana.id == "niebieska"
                          ? _c("p", { staticClass: "h4" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ic_kk_Oszczędzasz już przy 3 przejazdach tygodniowo"
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kalkulator.wybrana.id == "zielona"
                          ? _c("p", { staticClass: "h4" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ic_kk_Oszczędzasz już przy 4 przejazdach tygodniowo"
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "pt-4 mt-4" }, [_vm._v(" ")]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.kalkulator.wybrana.oszczednosc > 0
                    ? _c("div", [
                        _c("div", { staticClass: "h3" }, [
                          _vm._v(
                            _vm._s(_vm.$t("ic_kk_Darmowe przejazdy po")) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "h2" }, [
                          _vm._v(
                            _vm._s(_vm.kalkulator.wybrana.tydzien) +
                              ". " +
                              _vm._s(_vm.$t("ic_kk_tygodniu"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "h3" }, [
                          _vm._v(_vm._s(_vm.$t("ic_kk_Cena karty")) + ":"),
                          _c("br"),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatNumber")(
                                  _vm.kalkulator.wybrana.cena
                                )
                              ) +
                              " zł"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "h3" }, [
                          _vm._v(_vm._s(_vm.$t("ic_kk_Oszczędzasz")) + ": "),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "h3" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatNumber")(
                                  _vm.kalkulator.wybrana.oszczednosc
                                )
                              ) + " zł"
                            ),
                            _c("sup", [_vm._v("2")]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          return _vm.zamow(_vm.kalkulator.wybrana, $event)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("ic_kk_zamow")))]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.kalkulator.ilosc > 2
              ? _c("div", [
                  _c("h3", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.$t("ic_kk_inne warianty"))),
                  ]),
                  _vm._v(" "),
                  _vm.kalkulator.isCalculated
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between flex-column flex-md-row",
                        },
                        _vm._l(_vm.kalkulator.pozostale, function (karta) {
                          return _c(
                            "div",
                            {
                              key: karta.id,
                              staticClass: "wariant d-flex flex-column",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "karta", class: karta.id },
                                [
                                  _c("div", { staticClass: "head" }, [
                                    _c("p", [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t("ic_kk_Karta INTERCITY")
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(karta.name))]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(_vm.k_typ))]),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("ic_kk_KLASA")) +
                                            " " +
                                            _vm._s(_vm.kalkulator.klasa)
                                        ),
                                      ]),
                                      _vm._v(" - "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.k_discount)),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "light-blue" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("ic_kk_Darmowe przejazdy po")) +
                                    ":"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "okres" }, [
                                _vm._v(_vm._s(karta.tydzien) + ". tygodniu"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "cena" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("ic_kk_Cena karty")) + ": "
                                ),
                                _c("br"),
                                _vm._v(
                                  _vm._s(_vm._f("formatNumber")(karta.cena)) +
                                    " zł"
                                ),
                              ]),
                              _vm._v(" "),
                              karta.oszczednosc > 0
                                ? _c("span", { staticClass: "cena" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("ic_kk_Oszczędzasz")) + ": "
                                    ),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            karta.oszczednosc
                                          )
                                        ) + " zł"
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              karta.oszczednosc < 0
                                ? _c("span", { staticClass: "cena" }, [
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("span", [_vm._v(" ")]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.zamow(karta, $event)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("ic_kk_zamow")))]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("small", { staticClass: "mt-5 d-block" }, [
          _c("sup", [_vm._v("2")]),
          _vm._v(
            " " +
              _vm._s(
                _vm.$t(
                  "ic_kk_Oszczędność przy założeniu zakupu biletu w cenie bazowej, na przejazd pociągiem kategorii EIP (Pendolino), na przykładowej trasie Warszawa - Kraków lub Warszawa – Gdańsk."
                )
              )
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }